import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    // auth: {
    //     clientId: "6b4a23e0-5dc1-4757-ad65-4141fe871161",
    //     authority: "https://login.microsoftonline.com/2f8f64b7-4a1e-4612-9580-cb154e18e324",
    //     redirectUri: "http://localhost:3001/chat",
    // },

    auth: {
        clientId: "a5d20d37-8c3d-466a-8bd2-c70036a322ee",
        authority: "https://login.microsoftonline.com/2f8f64b7-4a1e-4612-9580-cb154e18e324/saml2",
        redirectUri: "https://rolo-frontend-506573180721.europe-west1.run.app/chat",
        postLogoutRedirectUri: "https://login.microsoftonline.com/2f8f64b7-4a1e-4612-9580-cb154e18e324/saml2",
        // rediretUri: "http://127.0.0.1:8080/chat"
    },
    
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
};

const loginRequest = {
    scopes: ["openid", "offline_access"]
};

const TOKEN_REQUEST = {
    scopes: ["User.ReadWrite.All"]
};

const GRAPH_CONFIG = {
    graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users"
};

const PUBLIC_CLIENT_APPLICATION = new PublicClientApplication(msalConfig);

export const initializeMsal = async () => {
    if (PUBLIC_CLIENT_APPLICATION && PUBLIC_CLIENT_APPLICATION.initialize) {
        await PUBLIC_CLIENT_APPLICATION.initialize();
    }
};

initializeMsal();

const msalInstance = new PublicClientApplication(msalConfig);

export {
    msalConfig,
    loginRequest,
    TOKEN_REQUEST,
    GRAPH_CONFIG,
    PUBLIC_CLIENT_APPLICATION,
    msalInstance
};